module.exports = ".main {\n  margin-bottom: 0;\n  height: calc(100vh - 90px); }\n"